import Head from "next/head";
import Image from "next/image";
import { useRouter } from "next/router";
import { useContext, useEffect } from "react";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";
import AuthService from "src/api/AuthService";
import Footer from "src/components/Footer";
import GoogleButton from "src/components/GoogleButton";
import { NewTextInput } from "src/components/Inputs/TextInput";
import LogoNavbar from "src/components/LogoNavbar";
import UserContext from "src/contexts/UserContext";
const debug = require("debug")("app:pages:Login");

//Can set "route" and "msg" with query params
export default function Login() {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<UserForm>();
  const { user, updateUser, logout } = useContext(UserContext);
  const router = useRouter();

  useEffect(() => {
    if (user?.type === "student") {
      debug("Redirect - login to dashboard cuz usertype student");
      router.push("/dashboard");
    } else if (user?.type === "admin") {
      debug("Redirect - login to admin cuz usertype admin");
      router.push("/admin");
    }
  }, [router, user]);

  const onSubmit = async (data: UserForm) => {
    debug("Submitted", data);
    if (!data.email || !data.password) {
      toast("Please fill out all fields");
      return;
    }

    try {
      const resp = await AuthService.login(data.email, data.password);
      debug("Resp", resp);
      updateUser && updateUser(resp.user);
      if (!resp.is_active) {
        toast("Check again later, your cohort has not been activated yet");
        logout && logout(true);
      } else if (resp.user?.type === "student") {
        debug("Redirect - login to dashboard");
        router.push("/dashboard");
      } else {
        debug("Redirect - login to admin");
        router.push("/admin");
      }
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <div className="h-screen w-screen bg-gray-100 flex flex-col">
      <Head>{/* <title>Login | {conf.get("PROJECT_NAME")}</title> */}</Head>
      <LogoNavbar />

      <div className="py-10 flex-1 flex items-center justify-center md:grid md:grid-cols-2 bg-white">
        <div className="md:col-span-1 justify-end mr-12 hidden md:flex">
          <div className="relative w-[420px] h-96 mt-10">
            <Image
              src="/loginImage.png"
              alt="student-image"
              fill
              style={{
                objectFit: "contain",
              }}
            />
          </div>
        </div>
        <div className="md:col-span-1 md:ml-12 min-w-[20rem]">
          <div className="flex-1 w-full flex flex-col justify-center items-center px-2 mb-20 mt-8 space-y-8 max-w-md">
            <div className="font-medium text-3xl w-full text-center">
              Log In
            </div>
            <GoogleButton
              onStudentSuccess={() => router.push("/dashboard")}
              onUserNotFound={() =>
                toast("User not found, try signing up instead")
              }
            />
            <div className="flex flex-row justify-between items-center w-full my-5">
              <div className="h-px bg-gray-400 flex-1 mr-3" />

              <div className="text-center text-xl text-black">or</div>
              <div className="h-px bg-gray-400 flex-1 ml-3" />
            </div>
            <form
              onSubmit={handleSubmit(onSubmit)}
              className="flex w-full flex-col gap-3"
            >
              <NewTextInput
                className="my-2 relative"
                name="email"
                title="Email"
                placeholder=" "
                register={register}
                errors={errors}
                required
                pattern={/^\S+@\S+$/i}
              />

              <NewTextInput
                className="mt-8 relative"
                name="password"
                title="Password"
                placeholder=" "
                register={register}
                errors={errors}
                required
                type="password"
              />
              <div
                className="font-medium mt-2 text-sm text-gray-500 cursor-pointer hover:text-gray-700"
                onClick={() => router.push("/reset")}
              >
                Forgot Password?
              </div>
              <button
                type="submit"
                className="bg-newSec py-2 rounded-md mt-6 mx-10 text-white shadow-xl uppercase tracking-wide"
              >
                Continue
              </button>

              <div className="flex flex-col justify-center items-center mt-4 mx-auto w-full">
                <div
                  className="font-medium text-gray-500 cursor-pointer hover:text-gray-700 text-sm group"
                  onClick={() => router.push("/signup")}
                >
                  Don't have an account?{" "}
                  <span className="text-sky-500 group-hover:text-sky-600 group-hover:underline">
                    Signup
                  </span>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}

/* <div className="flex-1 w-full flex flex-col items-center mb-20 mt-8">
        <div className="w-11/12 md:w-full max-w-lg relative border border-gray-200 bg-white px-8 py-8 rounded-lg shadow">
          <div className="font-medium text-3xl w-full text-center">Login</div>
          <div className="flex flex-row justify-center w-full mt-6">
            <GoogleButton
              onStudentSuccess={() => router.push("/dashboard")}
              onUserNotFound={() =>
                toast("User not found, try signing up instead")
              }
            />
          </div>

          <div className="flex flex-row justify-between items-center w-full my-5">
            <div className="h-px bg-gray-400 flex-1 mr-3" />

            <div className="text-center text-xl text-gray-400">or</div>
            <div className="h-px bg-gray-400 flex-1 ml-3" />
          </div>

          <form onSubmit={handleSubmit(onSubmit)}>
            <TextInput
              className="my-2"
              name="email"
              title="Email"
              register={register}
              errors={errors}
              required
              pattern={/^\S+@\S+$/i}
            />
            <TextInput
              className="mt-8"
              name="password"
              title="Password"
              register={register}
              errors={errors}
              required
              type="password"
            />
            <div
              className="font-medium mt-2 text-sm text-gray-500 cursor-pointer hover:text-gray-700"
              onClick={() => router.push("/reset")}>
              Forgot Password?
            </div>

            <div className="flex flex-col justify-center items-center mt-6 mx-auto w-full">
              <Button
                type="submit"
                size="lg"
                className="px-14"
                variant="primary">
                Let's Go
              </Button>
            </div>

            <div className="flex flex-col justify-center items-center mt-4 mx-auto w-full">
              <div
                className="font-medium text-gray-500 cursor-pointer hover:text-gray-700 text-sm group"
                onClick={() => router.push("/signup")}>
                Don't have an account?{" "}
                <span className="text-sky-500 group-hover:text-sky-600 group-hover:underline">
                  Sign up
                </span>
              </div>
            </div>
          </form>
        </div>
      </div> */
